/* eslint-disable max-len */

import { defineMessages } from 'react-intl';

export default defineMessages({
  step1Title: {
    id: 'create.step1.title',
    defaultMessage: 'Tell the world about your event',
  },
  step2Title: {
    id: 'create.step2.title',
    defaultMessage: 'Choose a time and place for your event',
  },
  step3Title: {
    id: 'create.step3.title',
    defaultMessage: 'Create your ticket types',
  },
  step3Warning: {
    id: 'create.step3.warning',
    // The leading asterisk is rendered separately as a styled span by the
    // consuming card, so it is deliberately absent from this string.
    defaultMessage: 'Some jurisdictions require taxes to be itemized — please be sure to itemize taxes where required after the event has been created.',
  },
  basics: {
    id: 'create.basics',
    defaultMessage: 'Basics',
  },
  additionalDetails: {
    id: 'create.additonalDetails',
    defaultMessage: 'Additional Details',
  },
  additionalDetailsHeader: {
    id: 'create.additionalDetailsHeader',
    defaultMessage: 'Add any additional details',
  },
  ageLimit: {
    id: 'create.ageLimit',
    defaultMessage: 'Add age limit',
  },
  ageLimitDetails: {
    id: 'create.ageLimitDetails',
    defaultMessage: 'The minimum age required to attend this event. This information will appear on this event’s details page, checkout flows, ticket confirmation email, and ticket information.',
  },
  ageLimitLabel: {
    id: 'create.ageLimitLabel',
    defaultMessage: 'Custom age limit'
  },
  ageLimitPlaceholder: {
    id: 'create.ageLimitPlaceholder',
    defaultMessage: 'Eg. 18+ with ID'
  },
  ageLimitErrorMessage: {
    id: 'create.ageLimitErrorMessage',
    defaultMessage: 'Cannot be empty.'
  },
  continueAdditionalDetails: {
    id: 'create.continueAdditionalDetails',
    defaultMessage: 'Continue to Additional Details',
  },
  timeLocation: {
    id: 'create.timeLocation',
    defaultMessage: 'Time and Location',
  },
  continueTimeLocation: {
    id: 'create.continueTimeLocation',
    defaultMessage: 'Continue to Time and Location',
  },
  continueSchedules: {
    id: 'create.continueSchedules',
    defaultMessage: 'Continue to Schedules',
  },
  tickets: {
    id: 'create.tickets',
    defaultMessage: 'Tickets',
  },
  selectAccount: {
    id: 'create.step1.selectAccount',
    defaultMessage: 'Select your account',
  },
  myAccount: {
    id: 'create.step1.myAccount',
    defaultMessage: 'My Account',
  },
  createEventAs: {
    id: 'create.step1.createEventAs',
    defaultMessage: 'Create event as',
  },
  eventName: {
    id: 'create.step1.eventName',
    defaultMessage: 'What is your event name?',
  },
  eventNamePlaceholder: {
    id: 'create.step1.eventNamePlaceholder',
    defaultMessage: 'Make it short and catchy',
  },
  description: {
    id: 'create.step1.description',
    defaultMessage: 'Describe your event',
  },
  descriptionPlaceholder: {
    id: 'create.step1.descriptionPlaceholder',
    defaultMessage: 'This description will appear on the event listing page.',
  },
  category: {
    id: 'create.step1.category',
    defaultMessage: 'Select a category for your event',
  },
  categoryContext: {
    id: 'create.step1.categoryContext',
    defaultMessage: 'This will help others find your event.',
  },
  categoryPlaceholder: {
    id: 'create.step1.categoryPlaceholder',
    defaultMessage: 'Select a category',
  },
  visibility: {
    id: 'create.step1.visibility',
    defaultMessage: 'Select who can see your event',
  },
  visibilityPublicContext: {
    id: 'create.step1.visibilityPublicContext',
    defaultMessage: 'Anyone can see and search for public events.',
  },
  visibilityUnlistedContext: {
    id: 'create.step1.visibilityUnlistedContext',
    defaultMessage: 'Only people with your event URL can see this event.',
  },
  unlistedErrorMessage: {
    id: 'create.step1.unlistedErrorMessage',
    defaultMessage: 'This event will no longer display on Ticketmaster.'
  },
  visibilityPublic: {
    id: 'create.step1.visibilityPublic',
    defaultMessage: 'Public',
  },
  visibilityUnlisted: {
    id: 'create.step1.visibilityUnlisted',
    defaultMessage: 'Unlisted',
  },
  startDate: {
    id: 'create.startDate',
    defaultMessage: 'Start date',
  },
  startTime: {
    id: 'create.startTime',
    defaultMessage: 'Time',
  },
  endDate: {
    id: 'create.endDate',
    defaultMessage: 'Date',
  },
  endTime: {
    id: 'create.endTime',
    defaultMessage: 'Time',
  },
  removeTime: {
    id: 'create.removeTime',
    defaultMessage: 'Remove time above',
  },
  hideDateTime: {
    id: 'create.step2.hideDateTime',
    defaultMessage: 'Hide the date and time from showing on tickets',
  },
  addAnotherTime: {
    id: 'create.step2.addAnotherTime',
    defaultMessage: 'Add another time',
  },
  address: {
    id: 'create.step2.address',
    defaultMessage: 'Address',
  },
  sampleCity: {
    id: 'create.step2.sampleCity',
    defaultMessage: 'e.g. 1 Park Avenue, Manhattan, New York',
  },
  nameOfVenue: {
    id: 'create.step2.nameOfVenue',
    defaultMessage: 'Venue name',
  },
  sampleVenue: {
    id: 'create.step2.sampleVenue',
    defaultMessage: 'e.g. City Hall Theatre',
  },
  ticketDetails: {
    id: 'create.step2.ticketDetails',
    defaultMessage: 'Ticket details',
  },
  continueTicketDetails: {
    id: 'create.step2.continueTicketDetails',
    defaultMessage: 'Continue to Tickets',
  },
  unlimited: {
    id: 'create.step3.unlimited',
    defaultMessage: 'Unlimited',
  },
  paidTicket: {
    id: 'create.step3.paidTicket',
    defaultMessage: 'Paid ticket',
  },
  freeTicket: {
    id: 'create.step3.freeTicket',
    defaultMessage: 'Free ticket',
  },
  donation: {
    id: 'create.step3.donation',
    defaultMessage: 'Donation',
  },
  showUrgencyIndicator: {
    id: 'create.step3.showUrgencyIndicator',
    defaultMessage: 'Show urgency indicators',
  },
  urgencyIndicatorsDesc: {
    id: 'create.step3.urgencyIndicatorsDesc',
    defaultMessage: 'If a day or time is close to selling out, urgency indicators will appear, encouraging buyers to hurry up.',
  },
  urgencyIndicatorLearnMore: {
    id: 'create.step3.urgencyIndicatorLearnMore',
    defaultMessage:
      'Learn more.'
  },
  timeslotCapacity: {
    id: 'create.step3.timeslotCapacity',
    defaultMessage: 'Timeslot capacity',
  },
  timeslotCapacityTooltip: {
    id: 'create.step3.timeslotCapacityTooltip',
    defaultMessage: 'The global default capacity for all timeslots on your event.',
  },
  copyOf: {
    id: 'create.step3.copyOf',
    defaultMessage: 'Copy of',
  },
  urgencyWarning: {
    id: 'create.step3.urgencyWarning',
    defaultMessage: 'This field is required to show urgency indicators.'
  },
  contactDetails: {
    id: 'create.step4.contactDetails',
    defaultMessage: 'Contact details',
  },
  contactDetailsContext: {
    id: 'create.step4.contactDetailsContext',
    defaultMessage: 'Your contact information is kept private and shown only to attendees who book a ticket.',
  },
  contactDetailsPlaceholder: {
    id: 'create.step4.contactDetailsPlaceholder',
    defaultMessage: 'Enter an email address or phone number',
  },
  additionalOrderMessage: {
    id: 'create.step4.additionalOrderMessage',
    defaultMessage: 'Additional order message',
  },
  additionalOrderMessageContext: {
    id: 'create.step4.additionalOrderMessageContext',
    defaultMessage: 'This message will appear on the ticket confirmation email and on the ticket itself.',
  },
  additionalOrderMessagePlaceholder: {
    id: 'create.step4.additionalOrderMessagePlaceholder',
    defaultMessage: 'Enter your additional order message',
  },
  socialMediaPhoto: {
    id: 'create.step4.socialMediaPhoto',
    defaultMessage: 'Social media photo',
  },
  socialMediaPhotoDimensions: {
    id: 'create.step4.socialMediaPhotoDimensions',
    defaultMessage: '(min 100x100px, max 2MB)',
  },
  eventPageCoverImage: {
    id: 'create.step4.eventPageCoverImage',
    defaultMessage: 'Event page cover photo',
  },
  eventPageCoverImageDimensions: {
    id: 'create.step4.eventPageCoverImageDimensions',
    defaultMessage: '(min 1110x444px, max 5MB, avoid including any text on the photo)',
  },
  addPhotoButton: {
    id: 'addPhotoButton',
    defaultMessage: 'Add Photo',
  },
  changePhotoButton: {
    id: 'changePhotoButton',
    defaultMessage: 'Change Photo',
  },
  addChangePhotosButton: {
    id: 'addChangePhotosButton',
    defaultMessage: 'Add/Change Photos',
  },
  saveAsDraft: {
    id: 'create.step4.saveAsDraft',
    defaultMessage: 'Save as draft',
  },
  schedule: {
    id: 'create.step4.schedule',
    defaultMessage: 'Schedule',
  },
  fanReminderPeriod: {
    id: 'create.step4.fanReminderPeriod',
    defaultMessage: 'Remind Me period:',
  },
  confirmSchedule: {
    id: 'create.step4.confirmSchedule',
    defaultMessage: 'Confirm schedule',
  },
  cancelSchedule: {
    id: 'create.step4.cancelSchedule',
    defaultMessage: 'Cancel schedule',
  },
  scheduledPublish: {
    id: 'create.step4.scheduledPublish',
    defaultMessage: 'Scheduled publish:',
  },
  editTime: {
    id: 'create.step4.editTime',
    defaultMessage: 'Edit time',
  },
  publishNow: {
    id: 'create.step4.publishNow',
    defaultMessage: 'Publish now',
  },
  addAdditionalImage: {
    id: 'create.step4.addAdditionalImage',
    defaultMessage: 'Additional photos',
  },
  addAdditionalImageDescription: {
    id: 'create.step4.addAdditionalImageDescription',
    defaultMessage:
      'Upload additional photos to help attendees imagine coming to your event like promotional photos, venue photos, etc.', // eslint-disable-line max-len
  },
  ticketLabelName: {
    id: 'create.ticket.labelName',
    defaultMessage: 'Ticket name',
  },
  ticketLabelQuantity: {
    id: 'create.ticket.labelQuantity',
    defaultMessage: 'Quantity',
  },
  ticketLabelPrice: {
    id: 'create.ticket.labelPrice',
    defaultMessage: 'Price',
  },
  ticketLabelActions: {
    id: 'create.ticket.labelActions',
    defaultMessage: 'Actions',
  },
  ticketAddAnother: {
    id: 'create.ticket.addAnother',
    defaultMessage: 'Add a ticket',
  },
  cancelButton: {
    id: 'create.imageCropper.cancelButton',
    defaultMessage: 'Cancel',
  },
  cropButton: {
    id: 'create.imageCropper.cropButton',
    defaultMessage: 'Crop',
  },
  categoryBusiness: {
    id: 'categories.business',
    defaultMessage: 'Business',
  },
  categoryComedy: {
    id: 'categories.comedy',
    defaultMessage: 'Comedy',
  },
  categoryCrafts: {
    id: 'categories.crafts',
    defaultMessage: 'Crafts',
  },
  categoryFashion: {
    id: 'categories.fashion',
    defaultMessage: 'Fashion',
  },
  categoryFilm: {
    id: 'categories.film',
    defaultMessage: 'Film',
  },
  categoryFood: {
    id: 'categories.foodAndDrink',
    defaultMessage: 'Food & Drink',
  },
  categoryGalleries: {
    id: 'categories.galleriesMuseums',
    defaultMessage: 'Galleries',
  },
  categoryMusic: {
    id: 'categories.music',
    defaultMessage: 'Music',
  },
  categoryOther: {
    id: 'categories.other',
    defaultMessage: 'Other',
  },
  categoryPerforming: {
    id: 'categories.performingArts',
    defaultMessage: 'Performances',
  },
  categorySocial: {
    id: 'categories.social',
    defaultMessage: 'Social',
  },
  categorySports: {
    id: 'categories.sports',
    defaultMessage: 'Sports',
  },
  categoryTech: {
    id: 'categories.tech',
    defaultMessage: 'Tech',
  },
  whereIsYourEvent: {
    id: 'create.step1.whereIsYourEvent',
    defaultMessage: 'Where is your event',
  },
  regularOrTimedEntry: {
    id: 'create.step0.oneTimeOrMultiTime',
    defaultMessage: 'Choose how you will set up your event',
  },
  regular: {
    id: 'create.step0.regular',
    defaultMessage: 'One-time events, in-person or virtual',
  },
  timedEntry: {
    id: 'create.step0.timedEntry',
    defaultMessage: 'One-time events, in-person or virtual',
  },
  regularInfo: {
    id: 'create.step0.regularInfo',
    defaultMessage: 'Best for: concerts, festivals, shows',
  },
  timedEntryInfo: {
    id: 'create.step0.timedEntryInfo',
    defaultMessage: 'Best for: exhibits, seasonal attractions, tours',
  },
  continue: {
    id: 'create.step0.continue',
    defaultMessage: 'Continue',
  },
  letsGetStarted: {
    id: 'create.step0.letsGetStarted',
    defaultMessage: "Let's get started!",
  },
  timedEntryTitle: {
    id: 'create.step0.timedEntryTitle',
    defaultMessage: "I'm hosting a multi-time event.",
  },
  regularTitle: {
    id: 'create.step0.regularTitle',
    defaultMessage: "Regular",
  },
  schedules: {
    id: 'create.schedules',
    defaultMessage: 'Schedules',
  },
  thisIsAVirtualEvent: {
    id: 'create.step2.thisIsAVirtualEvent',
    defaultMessage: 'This is a virtual event',
  },
  connectionDetails: {
    id: 'create.step2.connectionDetails',
    defaultMessage: 'Connection details',
  },
  connectionDetailsDescription: {
    id: 'create.step2.connectionDetailsDescription',
    defaultMessage: 'This information will be emailed to the buyer 1 hour before the event starts',
  },
  connectionDetailsPlaceholder: {
    id: 'create.step2.connectionDetailsPlaceholder',
    defaultMessage: 'You can access the stream directly at https://youtube.com/myevent',
  },
  paymentInfoTitle: {
    id: 'create.step3.paymentInfoTitle',
    defaultMessage: 'Set your currency and refund preferences'
  },
  businessSeller: {
    id: 'create.businessSeller',
    defaultMessage: 'I am registered as a Business Seller',
  },
  businessSellerTooltip: {
    id: 'create.businessSellerTooltip',
    defaultMessage: 'A Business Seller is someone selling as a `Trader` (i.e. acting for the purposes of a trader, business, craft or profession).',
  },
  businessSellerDetails: {
    id: 'create.businessSellerDetails',
    defaultMessage: 'Business Seller details',
  },
  businessSellerDetailsContext: {
    id: 'create.businessSellerDetailsContext',
    defaultMessage: 'As a Business Seller, you are required to provide buyers with your contact details. These details will be publicly available on the order confirmation email provided to buyers. Later edits can be made in the Profile tab of your Settings.',
  },
  businessAddress: {
    id: 'create.step4.businessAddress',
    defaultMessage: 'Address',
  },
  businessAddressContext: {
    id: 'create.step4.businessAddressContext',
    defaultMessage: 'Your address or the address to which your business is registered.',
  },
  businessAddressPlaceholder: {
    id: 'create.step4.businessAddressPlaceholder',
    defaultMessage: 'Enter an address',
  },
  businessPhone: {
    id: 'create.step4.businessPhone',
    defaultMessage: 'Phone number',
  },
  businessPhoneContext: {
    id: 'create.step4.businessPhoneContext',
    defaultMessage: 'Your telephone number or the telephone number of your business.',
  },
  businessPhonePlaceholder: {
    id: 'create.step4.businessPhonePlaceholder',
    defaultMessage: 'Enter phone number',
  },
  businessEmail: {
    id: 'create.step4.businessEmail',
    defaultMessage: 'Email',
  },
  businessEmailContext: {
    id: 'create.step4.businessEmailContext',
    defaultMessage: 'Your email address or the email address of your business.',
  },
  businessEmailPlaceholder: {
    id: 'create.step4.businessEmailPlaceholder',
    defaultMessage: 'Enter your business email address',
  },
  full: {
    id: 'create.step2.full',
    defaultMessage: 'Date and time in full',
  },
  startTimeOnly: {
    id: 'create.step2.startTimeOnly',
    defaultMessage: 'Start time only',
  },
  hideEventTime: {
    id: 'create.step2.hideEventTime',
    defaultMessage: 'Hide event time',
  },
  hideEventTimeError: {
    id: 'create.step2.hideEventTimeError',
    defaultMessage: "'Hide Event Time' can't be selected when multiple timeslots have been created. We've updated your setting to show the full date and time.",
  },
  timeDisplayedOnTicket: {
    id: 'create.step2.timeDisplayedOnTicket',
    defaultMessage: 'Time displayed on ticket and checkout',
  },
  hideSoldOutTicketTypes: {
    id: 'create.step3.hideSoldOutTicketTypes',
    defaultMessage: 'Hide sold out ticket types',
  },
  hideSoldOutTicketTypesTooltip: {
    id: 'create.step3.hideSoldOutTicketTypesTooltip',
    defaultMessage: 'Automatically hide sold out ticket types in checkout. Ticket types will re-appear if capacity increases.',
  },
});

/* eslint-enable max-len */
